const FOOTER_LINKS = {
  追漫导航: ['热门韩漫', '人气日漫', '国漫精选', '完结漫画', '新番上架'],
  读者服务: ['追漫提醒', '阅读记录', '我的书架', '离线缓存', '夜间模式'],
  关于我们: ['平台介绍', '投稿合作', '意见反馈', '用户协议', '隐私政策'],
  合作伙伴: [],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
          <div className="col-span-2 sm:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-chat-smile-2-line text-base text-background-50"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50">番茄漫画</span>
            </div>
            <p className="text-xs text-background-400 leading-relaxed mb-4">
              追更漫画连载更新平台，提供最新话追漫提醒、免费全集完结韩漫日漫国漫，
              流畅下拉式滚动在线阅读体验，追漫必备。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer no-underline">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer no-underline">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer no-underline">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-heading font-bold text-background-50 mb-4">{title}</h4>
              {links.length > 0 ? (
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link}>
                      <a
                        href="#"
                        className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer no-underline"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-xs text-background-500 italic">敬请期待</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 番茄漫画 fanqiecomic.com · 专注漫画追更体验
          </p>
          <p className="text-xs text-background-600">
            本站内容仅供学习交流，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}